import React, { useState, useEffect, useRef } from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/MoreCard.js';
import * as d3 from 'd3';

import axios from 'axios';

export default function Conversion(props) {
  const { ...rest } = props;

  // Chakra Color Mode
  const cardColor = useColorModeValue('white', 'navy.700');
  const cardShadow = useColorModeValue(
    '0px 18px 40px rgba(112, 144, 176, 0.12)',
    'unset'
  );

  const [imageBase64, setImageBase64] = useState("");
  const [error, setError] = useState(null); // Initialize error state

  const ref = useRef();
  const tooltipRef = useRef();


  const data = [
    { name: 'Deceased', value: 30 },
    { name: 'Alive', value: 50 },
    // { name: 'C', value: 70 },
    // { name: 'D', value: 40 }
  ];

  const width = 500;
  const height = 250;
  const margin = { top: 20, right: 20, bottom: 50, left: 40 };

  useEffect(() => {
    // Check if selectedOption is not null and has a value field
    if (props.selectedOption && props.selectedOption.value) {
      // Use the selectedOption.value in the API URL
      //   const apiUrl = `http://localhost:8000/api/get-survival-statistics/?project=${props.selectedOption.value}`;
      // const apiUrl = `http://localhost:8000/api/get-crosstalk-enrichment/?project=${props.selectedOption.value}`;
      // const api_host = "http://glycopeptideatlas-eb-env.eba-zxebtsmp.us-west-2.elasticbeanstalk.com"
      // const apiUrl = `${api_host}/api/get-survival-statistics/?project=${props.selectedOption.value}`;


      // axios.get(apiUrl)
      //   .then(response => {
      //     setImageBase64(response.data.image_base64);
      //   })
      //   .catch(err => {
      //     setError("Failed to fetch image."); // Set error state
      //     console.error("Error fetching image: ", err);
      //   });

      const svg = d3.select(ref.current);
      const tooltip = d3.select(tooltipRef.current);

      const xScale = d3.scaleBand()
        .domain(data.map(d => d.name))
        .range([margin.left, width - margin.right])
        .padding(0.2);

      const yScale = d3.scaleLinear()
        .domain([0, d3.max(data, d => d.value)])
        .range([height - margin.bottom, margin.top]);

      // Draw bars
      const bars = svg.selectAll('rect')
        .data(data);

      bars.enter()
        .append('rect')
        .attr('x', d => xScale(d.name))
        .attr('y', d => yScale(d.value))
        .attr('width', xScale.bandwidth())
        .attr('height', d => height - margin.bottom - yScale(d.value))
        .attr('fill', '#3182bd');


      // Create and draw the x-axis
      const xAxis = d3.axisBottom(xScale);

      svg.append('g')
        .attr('transform', `translate(0, ${height - margin.bottom})`)
        .call(xAxis);

      // Optionally: Create and draw the y-axis
      const yAxis = d3.axisLeft(yScale);
      svg.append('g')
        .attr('transform', `translate(${margin.left}, 0)`)
        .call(yAxis);

      svg
        .append('text')
        .text('Vital Status')
        .style('font-family', 'Arial')
        .style('font-weight', 'bold')
        .style('font-size', '1.2rem')
        .style('text-anchor', 'middle')
        .attr('x', width / 2)
        .attr('y', height);
      svg
        .append('text')
        .text('Count')
        .style('font-family', 'Arial')
        .style('font-weight', 'bold')
        .style('font-size', '1.2rem')
        .style('text-anchor', 'middle')
        .attr('x', margin.left / 2 - 5)
        .attr('transform', `rotate(-90, ${margin.left / 2 - 5}, ${height / 2})`)
        .attr('y', height / 2);

      svg
        .selectAll('rect')
        .on('mouseenter', function (event, d) {
          const [x, y] = d3.pointer(event, this);
        tooltip.style('display', 'block')
          .style('left', (x-10) + 'px')
          .style('top', (y + 20) + 'px')
          .text(d.value);
          d3.select(this).transition().duration(300).attr('fill', '#FF0000');
        })
        .on('mouseleave', function () {
          tooltip.style('display', 'none');
          d3.select(this).transition().duration(300).attr('fill', '#3182bd');
        });

      // bars.on('mouseenter', function (event, d) {
      //   const [x, y] = d3.pointer(event, this);
      //   tooltip.style('display', 'block')
      //     .style('left', x + 'px')
      //     .style('top', (y + 20) + 'px')
      //     .text(d.value);
      //   d3.select(this).transition().duration(300).attr('fill', '#FF0000');
      // })
      //   .on('mouseleave', function () {
      //     tooltip.style('display', 'none');
      //     d3.select(this).transition().duration(300).attr('fill', '#3182bd');
      //   });




    }
  }, [width, height, margin, props.selectedOption]);

  return (
    <Card data={data} svgRef={ref}  p='20px' align='center' direction='column' w='100%' {...rest}>
      <div className="App">
        <h3>Sample Profile</h3>
        <div style={{ textAlign: 'center' }}>
          <div ref={tooltipRef} style={{
            position: 'absolute',
            display: 'none',
            backgroundColor: 'white',
            padding: '5px',
            borderRadius: '5px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)'
          }}></div>
          <svg ref={ref} width="100%" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="xMidYMid meet"></svg>
        </div>
        {error && <p>{error}</p>} {/* Display error message */}
      </div>
    </Card>
  );
}

